<template>
  <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M0 23.1284C0 34.5633 8.30492 44.0718 19.1667 46V29.3883H13.4167V23H19.1667V17.8883C19.1667 12.1383 22.8716 8.94508 28.1117 
    8.94508C29.7716 8.94508 31.5618 9.2 33.2216 9.45492V15.3333H30.2833C27.4716 15.3333 26.8333 16.7382 26.8333 
    18.5284V23H32.9667L31.9451 29.3883H26.8333V46C37.6951 44.0718 46 34.5652 46 23.1284C46 10.4075 35.65 0 23 0C10.35 0 0 10.4075 
    0 23.1284Z" 
  />
</template>

<script>
export default {

}
</script>

<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);
        fill: var(--iconTextColor);
        stroke: var(--iconBorderColor);
    }
</style>